import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import MultilineTextFields from './MultilineTextFields';
import ClientProvider from './client';
export default createDemo(import.meta.url, MultilineTextFields, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/text-fields/demos/multiline/MultilineTextFields.tsx",
    "fileName": "MultilineTextFields.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport TextField from '@mui/material/TextField';\n\nexport default function MultilineTextFields() {\n  return (\n    <Box\n      component=\"form\"\n      sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}\n      noValidate\n      autoComplete=\"off\"\n    >\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <div>\n        <TextField\n          id=\"outlined-multiline-flexible\"\n          label=\"Multiline\"\n          multiline\n          maxRows={4}\n        />\n        <TextField\n          id=\"outlined-textarea\"\n          label=\"Multiline Placeholder\"\n          placeholder=\"Placeholder\"\n          multiline\n        />\n        <TextField\n          id=\"outlined-multiline-static\"\n          label=\"Multiline\"\n          multiline\n          rows={4}\n          defaultValue=\"Default Value\"\n        />\n      </div>\n      <div>\n        <TextField\n          id=\"filled-multiline-flexible\"\n          label=\"Multiline\"\n          multiline\n          maxRows={4}\n          variant=\"filled\"\n        />\n        <TextField\n          id=\"filled-textarea\"\n          label=\"Multiline Placeholder\"\n          placeholder=\"Placeholder\"\n          multiline\n          variant=\"filled\"\n        />\n        <TextField\n          id=\"filled-multiline-static\"\n          label=\"Multiline\"\n          multiline\n          rows={4}\n          defaultValue=\"Default Value\"\n          variant=\"filled\"\n        />\n      </div>\n      <div>\n        <TextField\n          id=\"standard-multiline-flexible\"\n          label=\"Multiline\"\n          multiline\n          maxRows={4}\n          variant=\"standard\"\n        />\n        <TextField\n          id=\"standard-textarea\"\n          label=\"Multiline Placeholder\"\n          placeholder=\"Placeholder\"\n          multiline\n          variant=\"standard\"\n        />\n        <TextField\n          id=\"standard-multiline-static\"\n          label=\"Multiline\"\n          multiline\n          rows={4}\n          defaultValue=\"Default Value\"\n          variant=\"standard\"\n        />\n      </div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 83,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport TextField from '@mui/material/TextField';\n\nexport default function MultilineTextFields() {\n  return (\n    <Box\n      component=\"form\"\n      sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}\n      noValidate\n      autoComplete=\"off\"\n    >\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <div>\n        <TextField\n          id=\"outlined-multiline-flexible\"\n          label=\"Multiline\"\n          multiline\n          maxRows={4}\n        />\n        <TextField\n          id=\"outlined-textarea\"\n          label=\"Multiline Placeholder\"\n          placeholder=\"Placeholder\"\n          multiline\n        />\n        <TextField\n          id=\"outlined-multiline-static\"\n          label=\"Multiline\"\n          multiline\n          rows={4}\n          defaultValue=\"Default Value\"\n        />\n      </div>\n      <div>\n        <TextField\n          id=\"filled-multiline-flexible\"\n          label=\"Multiline\"\n          multiline\n          maxRows={4}\n          variant=\"filled\"\n        />\n        <TextField\n          id=\"filled-textarea\"\n          label=\"Multiline Placeholder\"\n          placeholder=\"Placeholder\"\n          multiline\n          variant=\"filled\"\n        />\n        <TextField\n          id=\"filled-multiline-static\"\n          label=\"Multiline\"\n          multiline\n          rows={4}\n          defaultValue=\"Default Value\"\n          variant=\"filled\"\n        />\n      </div>\n      <div>\n        <TextField\n          id=\"standard-multiline-flexible\"\n          label=\"Multiline\"\n          multiline\n          maxRows={4}\n          variant=\"standard\"\n        />\n        <TextField\n          id=\"standard-textarea\"\n          label=\"Multiline Placeholder\"\n          placeholder=\"Placeholder\"\n          multiline\n          variant=\"standard\"\n        />\n        <TextField\n          id=\"standard-multiline-static\"\n          label=\"Multiline\"\n          multiline\n          rows={4}\n          defaultValue=\"Default Value\"\n          variant=\"standard\"\n        />\n      </div>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "totalLines": 83,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/TextField"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
